import { render, staticRenderFns } from "./BaseFormField.vue?vue&type=template&id=b339145e&scoped=true&"
import script from "./BaseFormField.vue?vue&type=script&lang=js&"
export * from "./BaseFormField.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormField.vue?vue&type=style&index=0&id=b339145e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b339145e",
  null
  
)

export default component.exports